import EventActionProto from '../event-action-proto'

class EventUsersReset extends EventActionProto {

    constructor(uid, data) {
        super(uid, data);
    }

    validate() {
        return true;
    }

    process() {
        gd.session.users.resetAndKeepOldModels(this.data)

        super.process();
    }
}


module.exports = EventUsersReset;